<template>
  <h-tour-dialog v-model="show">
    <div class="text-center text-h4 font-weight-bold mb-6" v-text="__('tour1Title')" />
    <p class="text-h6" v-text="__('tour1Text')" />
    <div class="my-8 text-subtitle-1">
      <div
        v-for="(option, i) in options"
        :key="i"
        class="ma-4"
      >
        <v-icon left v-text="icons[option.icon]" />{{ __(option.text) }}
      </div>
    </div>
  </h-tour-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HTourDialog from './Dialog'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HTourDialog,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      options: [
        { icon: 'prev', text: 'tour1Save' },
        { icon: 'plusCircle', text: 'tour1Add' },
        { icon: 'coins', text: 'tour1Charge' },
      ],
    }),

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
    },
  }
</script>
